import { Stack } from "@chakra-ui/react";
import { FC, useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import CategorySelector from "./CategorySelector";
import PosNegSelector from "./components/PosNegSelector";
import ReviewCard from "./components/ReviewCard";
import SkeletonReviewCard from "./components/ReviewCardSkeleton";
import useReviewPage from "./useReviewPage";

const ReviewsPage: FC = () => {
  const {
    reviews,
    evalKey,
    setEvalKey,
    categoryKey,
    onCategoryKeyChange,
    isLoading,
    existMore,
    fetchNextPage,
  } = useReviewPage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Stack spacing={6}>
      <div className="is-flex">
        <CategorySelector
          onChange={onCategoryKeyChange}
          current={categoryKey}
        />
        <PosNegSelector
          onChange={setEvalKey}
          current={evalKey}
          currentCategory={categoryKey}
        />
      </div>
      <div>
        {isLoading ? (
          [0, 1, 2, 3, 4].map((a) => <SkeletonReviewCard key={a} />)
        ) : reviews.length === 0 ? (
          <p className="my-2">該当するアンケートがありませんでした。</p>
        ) : (
          <Stack spacing={4}>
            {reviews.map((review) => (
              <ReviewCard key={review.qId} review={review} />
            ))}
          </Stack>
        )}

        {existMore && (
          <div className="is-flex is-justify-content-center mt-5">
            <button className="button" onClick={() => fetchNextPage()}>
              もっと見る
            </button>
          </div>
        )}
      </div>
    </Stack>
  );
};

export default ReviewsPage;
